import React from 'react';
import { Alert } from 'reactstrap';
const AlertErrors = props => props.errors.length > 0 ? /*#__PURE__*/React.createElement(Alert, {
  color: "danger"
}, props.errors.map((error, idx) => /*#__PURE__*/React.createElement("div", {
  key: "alert_".concat(idx + 1)
}, error))) : /*#__PURE__*/React.createElement("div", null);
export default AlertErrors;